
<div [hidden]="showForm">
  <h4>
    Préstamos
  </h4>

  <button class="btn btn-primary"
          type="button"
          (click)="addNew()">
    Agregar
  </button>

  <hr />

  <app-generic-grid #grid
                    (rowToEdit)="edit($event)"
                    (rowToDelete)="delete($event)">
  </app-generic-grid>

</div>
<!-- grid container -->

<div [hidden]="!showForm">

  <div class="row">
    <div class="col-md-6 col-sm-12 mx-auto">

      <h5 *ngIf="!isEdition">Agregar Préstamo</h5>
      <h5 *ngIf="isEdition">Editar Préstamo</h5>

      <hr />
      <br />

      <form [formGroup]="loanForm">

        <app-employee-selector #employeeSelector
                               [hidden]="isEdition">
        </app-employee-selector>

        <igx-input-group *ngIf="isEdition">
          <input igxInput name="EmployeeName"
                 [(ngModel)]="employeeName"
                 [ngModelOptions]="{standalone: true}"
                 readonly="true"
                 type="text"
                 aria-label="Empleado" />
          <label igxLabel for="EmployeeName">Empleado</label>
        </igx-input-group>

        <igx-input-group>
          <input igxInput name="Authorizer"
                 [ngClass]="{'is-invalid': loanForm.get('Authorizer').errors && loanForm.get('Authorizer').touched}"
                 type="text"
                 aria-label="Autoriza"
                 formControlName="Authorizer" />
          <label igxLabel for="Authorizer">Autoriza</label>
        </igx-input-group>

        <igx-input-group>
          <input igxInput name="Amount"
                 [ngClass]="{'is-invalid': loanForm.get('Amount').errors && loanForm.get('Amount').touched}"
                 type="number"
                 aria-label="Monto"
                 formControlName="Amount" />
          <label igxLabel for="Amount">Monto</label>
        </igx-input-group>

        <igx-input-group>
          <input igxInput name="WeeklyPayment"
                 [ngClass]="{'is-invalid': loanForm.get('WeeklyPayment').errors && loanForm.get('WeeklyPayment').touched}"
                 type="number"
                 aria-label="Pago Semanal"
                 formControlName="WeeklyPayment" />
          <label igxLabel for="WeeklyPayment">Pago Semanal</label>
        </igx-input-group>

        <br />
        <hr />

        <div class="d-flex justify-content-between">
          <button class="btn btn-primary"
                  *ngIf="!isEdition"
                  type="submit"
                  [disabled]="!isValidForm()"
                  (click)="save()">
            Guardar
          </button>
          <button class="btn btn-primary"
                  *ngIf="isEdition"
                  type="submit"
                  [disabled]="!isValidForm()"
                  (click)="update()">
            Guardar cambios
          </button>

          <button class="btn btn-secondary"
                  type="button"
                  (click)="cancel()">
            Cancelar
          </button>
        </div>

      </form>

    </div>
  </div>

</div>
<!-- form container -->
